import React from 'react';
const TypographyCurrency = (props) => {
    return <span className={`${props.className}`}>
            {/*<span className={`${props.className} currency-flag currency-flag-${(props.iso_alpha_3 || '').toLowerCase()}`}*/}
        {/*      style={{...props.styles, marginBottom: '-3px', marginRight: '3px' }} />*/}
        {/*<span>{props.children}</span>*/}

        <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '5px'
        }}>
            {props.right ? <span> {props.children}</span> : ''}
            <img alt='currency'
                 src={`https://fwwportal-branding.s3.us-east-1.amazonaws.com/currencies/${(props.iso_alpha_3 || '').toLowerCase()}.png`}
                 width="24px" height="16px"/>
            {
                !props.right ? <span> {props.children}</span> : ''
            }
        </div>

    </span>

}

export default TypographyCurrency;